import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../../components/common/SpinnerComponentUI'
import MappingGroupUpdateModalSF from './MappingGroupUpdateModalSF'
import './LoanPropertyList.css'
import MappingGroupCreateModalSF from './MappingGroupCreateModalSF'

const MappingListUI = ({ context, propertyList, errorList,
  // modes
  createMode, onCreateModeClick, onCreateCancelClick,
  updateMode, selectedProperty, category, categoryLabel,
  // event handlers
  onRefreshClick, onUpdateClick, onCancelClick, onUpdate,
  //fundSource
  flag, totalOutStandingLoan, totalSecurityAmount, totalDsraCurrent
}) =>
  <CardUI className='su_l_props g_m_top_100' title={categoryLabel} noUnderline={true}>
    {
      !propertyList &&
      <SpinnerComponentUI />
    }
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <IconButtonUI icon='icon-plus' onClick={onCreateModeClick} />
          <span className='g_m_left_100'><b>Lender's Total Amount</b></span>
        </span>
      }
      right={<span />}
    />
    <LRTableBodyUI>
      {
        propertyList && propertyList.map((property, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} property={property} />}
            right={<RowRightUI property={property} onUpdateClick={onUpdateClick}  flag={flag} 
            totalOutStandingLoan={totalOutStandingLoan} totalSecurityAmount={totalSecurityAmount} totalDsraCurrent={totalDsraCurrent}/>}
          />
        )
      }
    </LRTableBodyUI>

    <MappingGroupUpdateModalSF
      context={context}
      updateMode={updateMode}
      mappingGroup={category}
      mappedValueList={propertyList}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedMapping={selectedProperty}
    />
    <MappingGroupCreateModalSF
      context={context}
      createMode={createMode}
      mappingGroup={category}
      onCancelClick={onCreateCancelClick}
      onRefreshClick={onRefreshClick}
    />
  </CardUI>

const RowLeftUI = ({ context, i, property }) =>
  <div className='g_flex_h g_flex_left'>
    {
      property.propertyCode !== 'term_sheet_special_terms' &&
      <>
        <span className='g_m_right_50'>
          {i}
        </span>
        <span>
          {property.sourceValue}<br />
          {
            property.hint &&
            <span className='g_muted g_small'>{property.hint}</span>
          }
        </span>
      </>
    }
  </div>

const RowRightUI = ({ property, onUpdateClick, flag, totalOutStandingLoan, totalSecurityAmount, totalDsraCurrent }) =>
  <div>
    <div className={`g_flex_h g_m_left_100 g_flex_top g_flex_right`}>
      {
        property.mappedValue &&
        <span>{property.mappedValue}</span>
      }
      <span className='icon icon-pencil g_link_2 g_m_left_50'
        data-property={property.mappingId} onClick={onUpdateClick} />
    </div>
    {
      
      <span className='g_small g_muted'>Security Amount: {`${(convertStringToInteger(property.mappedValue) / ( 
        convertStringToInteger(totalOutStandingLoan) + convertStringToInteger(totalSecurityAmount) + 
        convertStringToInteger(totalDsraCurrent))).toFixed(2)}`}</span>
    }
  </div>

function convertStringToInteger(numberString) {
  // console.log(numberString)
  if (typeof numberString !== 'string') {
    return NaN;
  }
  const answer = parseInt(numberString.replace(/,/g, ""), 10)
  // console.log('final: '+ answer)
  return answer
}
export default MappingListUI
